/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowHerbalWorkshopTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowHerbalWorkshop,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Let’s Explore Herbs Together!",
    "Herbal Workshop Awaits!",
    "Nurture with Nature!",
  ],
  title: "Herbal Workshop",
  description: "Organize a fun herbal workshop.",
  longDescription:
    "Gather your friends for an engaging herbal workshop! Choose a date, decide on herbs to explore, and plan materials needed!",
  emoji: "🌱",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Woodworker,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Herbal Workshop",
          emoji: "🌱",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we hold the herbal workshop?",
          emoji: "📅",
          completeAction: {
            question: "Decide on herbs to explore?",
            description: "What herbs should we focus on during the workshop?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What herbs should we consider?",
                emoji: "🌿",
                completeAction: {
                  question: "Decide on products to make?",
                  description: "What herbal products should we plan to create?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What products should we bring?",
                      emoji: "💧",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Let’s Grow Together!",
    outroDescription:
      "Your herbal workshop plans are set! Enjoy the exploration!",
  },
};
